import { Button, Card, Form, Input, Row, Typography, message } from "antd";
import { useMediaQuery } from "react-responsive";
import { Link, useNavigate } from "react-router-dom";
import { LoginContainer } from "../../components";
import HTTPClient from "../../utils/HTTPClient";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

export default function RecoverPassword({}) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    return (
        <LoginContainer>
            <Row justify="center" align="middle">
                <h1
                    style={{
                        color: "#fff",
                        font: '"Open Sans", sans-serif"',
                        letterSpacing: "-0.2px",
                        fontSize: "3rem",
                        marginBottom: "0.3em",
                        marginTop: !isLargeScreen ? "0" : "",
                    }}></h1>
            </Row>
            <Row justify="center" align="middle" style={{ marginBottom: "3.5em" }}>
                <Text
                    style={{
                        color: "#fff",
                        font: '"Open Sans", sans-serif"',
                        letterSpacing: "-0.2px",
                        textAlign: "center",
                        padding: "1.25rem ",
                        fontSize: "1.5rem",
                    }}>
                    {t("recover_password.title")}
                </Text>{" "}
            </Row>

            <Row justify="center" align="middle">
                <Card
                    bodyStyle={{ padding: 0 }}
                    style={{
                        minWidth: isLargeScreen ? "26rem" : "90%",
                        padding: "2.25rem 1.75rem 1.25rem 1.75rem",
                        marginBottom: "3rem",
                    }}>
                    <Form
                        validateTrigger="onSubmit"
                        name="basic"
                        onFinish={(values) => {
                            const { email } = values;
                            HTTPClient.post("/auth/recover_password", { email })
                                .then((res) => {
                                    message.success(t("recover_password.success"));
                                    navigate("/login");
                                })
                                .catch((e) => {
                                    message.error(t("recover_password.error"));
                                });
                        }}
                        autoComplete="off"
                        style={{ padding: "0px" }}>
                        <Form.Item
                            name="email"
                            rules={[
                                {
                                    type: "email",
                                    required: true,
                                    message: t("recover_password.email_error"),
                                },
                            ]}>
                            <Input placeholder={"Email"} style={{ height: "3rem" }} />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                htmlType="submit"
                                type="primary"
                                style={{
                                    display: "inline-block",
                                    width: "100%",
                                    height: "3.125rem",
                                    borderRadius: "1.5rem",
                                    color: "#fff",
                                    font: ' 700 0.875rem/0 "Open Sans", sans-serif',
                                    cursor: "pointer",
                                    transition: "all 0.2s",
                                }}>
                                {t("recover_password.call_to_action")}
                            </Button>
                        </Form.Item>
                    </Form>
                    <div style={{ textAlign: "center" }}>
                        <Text
                            style={{
                                font: '"Open Sans", sans-serif"',
                                letterSpacing: "-0.2px",
                            }}>
                            <Link to={"/login"} style={{ textDecoration: "none" }}>
                                {t("recover_password.back_to_login")}
                            </Link>
                        </Text>{" "}
                    </div>
                </Card>
            </Row>
        </LoginContainer>
    );
}
